import { ErrorHandlingModeType } from "../../Configurator/Types/ConfiguratorTypes";
import FansUnitedSdkException from "../../Exception/FansUnitedSdkException";
import StandardFansUnitedException from "../../Exception/StandardFansUnitedException";

export default class BaseValidator {
  private errorHandlingModel: ErrorHandlingModeType = null;

  constructor(errorHandlingModel: ErrorHandlingModeType) {
    this.errorHandlingModel = errorHandlingModel;
  }

  public throwException = (
    code: number,
    status: string,
    message: string
  ) => {
    if (this.errorHandlingModel === "standard") {
      throw new StandardFansUnitedException(code, status, message);
    }
    throw new FansUnitedSdkException(code, status, message);
  };
}
